import { Info, SquareKanban } from 'lucide-react';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { Tooltip } from 'primereact/tooltip';

import { CUBE_LABELS, ORDER_BY } from '../constant/constant';

import TableDetails from './TableDetails';
import GroupBySection from './GroupBySection';

const ReportConfiguration = ({
  tableList,
  selectedTable,
  setSelectedTable,
  action,
  widgetFormik,
  updateTableFilter,
  dimensionList,
  isWarrantyEnabled,
  tableMeasures,
}) => {
  const headerTemplate = () => {
    return (
      <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
        <SquareKanban className="text-primary text-sm w-1rem h-1rem" />
        <span className="text-sm font-bold text-gray-500">
          Report Configuration
        </span>
      </div>
    );
  };

  return (
    <Panel header={headerTemplate} className="w-full">
      <div className="grid w-full border-1 border-solid border-round border-200 grid-nogutter">
        <div className="grid grid-nogutter col md:col-3 p-2 gap-2 align-items-center">
          <div className="col-10 p-0">
            <span className="p-float-label">
              <Dropdown
                showClear
                filter
                id="chartTable"
                options={tableList}
                disabled={
                  action === 'view' || widgetFormik.values.route_widget
                    ? true
                    : false
                }
                optionLabel="value"
                optionValue="value"
                value={
                  selectedTable === CUBE_LABELS.USER_DETAILS
                    ? tableList.find(item => item.key === CUBE_LABELS.USER_META)
                        ?.value
                    : tableList.find(
                        item =>
                          item.key === selectedTable.replace(/ /g, '') ||
                          item.title === selectedTable.replace(/ /g, '') ||
                          item.title === selectedTable
                      )?.value
                }
                className="w-full"
                onChange={event => {
                  const selectedLabel = event.value;

                  const fullObject = tableList.find(
                    item => item.value === selectedLabel
                  );
                  widgetFormik.setFieldValue('report_group_by', null);
                  widgetFormik.setFieldValue('report_group_by_aggr', null);
                  setSelectedTable(event?.value || '');
                  updateTableFilter({
                    ...widgetFormik.values,
                    custom_properties: {
                      ...widgetFormik.values.custom_properties,
                      selectedReportTable: event?.value || '',
                      reportTablePrimaryKey: fullObject?.primaryKey || '',
                    },
                  });
                }}
              />
              <label htmlFor="chartTable">
                Report Source <span className="text-red-400">*</span>
              </label>
            </span>
          </div>
          <div className="col-1 p-0">
            <Info
              className="text-primary text-sm w-1rem h-1rem report-source-icon"
              data-pr-tooltip=" Select a Report Source to configure report"
              data-pr-position="bottom"
            />
            <Tooltip
              target=".report-source-icon"
              pt={{
                root: { className: 'p-2' },
                text: { className: 'text-xs' },
              }}
            />
          </div>
        </div>
        <Divider layout="vertical" />
        <div className="col grid grid-nogutter p-2 gap-3 align-items-center">
          <TableDetails
            dimensionList={dimensionList?.filter(item => {
              let flag = true;
              if (item?.meta?.tenantPermission) {
                flag = isWarrantyEnabled();
              }
              return (
                item?.firstLetter ===
                  selectedTable?.replace(/([a-z](?=[A-Z]))/g, '$1 ') &&
                item?.name !== item?.primaryKey &&
                !item?.meta?.hideInDimension &&
                flag
              );
            })}
            action={action}
            widgetFormik={widgetFormik}
          />
        </div>
      </div>
      <div className="grid w-full grid-nogutter mt-4 gap-2">
        <div className="col-6 md:col-3">
          <span className="p-float-label">
            <Dropdown
              showClear
              id="orderByField"
              key={widgetFormik.values.order_by.orderField}
              options={widgetFormik.values.table_configuration}
              disabled={action === 'view' ? true : false}
              optionLabel={'alice'}
              className="w-full"
              value={
                widgetFormik.values.table_configuration.find(
                  item =>
                    item.measureName == widgetFormik.values.order_by.orderField
                ) || ''
              }
              onChange={event => {
                widgetFormik.values.order_by.orderField =
                  event?.target?.value?.measureName || '';
                widgetFormik.setFieldValue(
                  'order_by',
                  widgetFormik.values.order_by
                );
              }}
            />
            <label htmlFor="orderByField">
              Order By Field <i className="text-red-400">*</i>
            </label>
          </span>
        </div>
        <div className="col-6 md:col-3">
          <span className="p-float-label">
            <Dropdown
              showClear
              id="orderBy"
              key={widgetFormik.values.order_by.orderField}
              options={ORDER_BY}
              disabled={action === 'view' ? true : false}
              optionLabel={'value'}
              className="w-full"
              value={
                ORDER_BY.find(
                  item => item.name == widgetFormik.values.order_by.orderBy
                )?.value
              }
              onChange={event => {
                const selectedLabel = event.value;

                const fullObject = ORDER_BY.find(
                  item => item.value === selectedLabel
                );
                widgetFormik.values.order_by.orderBy = fullObject?.name || '';
                widgetFormik.setFieldValue(
                  'order_by',
                  widgetFormik.values.order_by
                );
              }}
            />
            <label htmlFor="orderByField">
              Order By <i className="text-red-400">*</i>
            </label>
          </span>
        </div>
      </div>
      {tableMeasures.length > 0 && widgetFormik.values.is_third_party !== 1 && (
        <div className="grid w-full grid-nogutter mt-3 gap-2">
          <GroupBySection
            action={action}
            widgetFormik={widgetFormik}
            dimensionList={dimensionList?.filter(
              item => item.firstLetter === selectedTable
            )}
            measures={tableMeasures}
          />
        </div>
      )}
    </Panel>
  );
};

export default ReportConfiguration;
